import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

function getShouldHideLoyaltyStatusCreditsAndNights(state: App.State): boolean {
  return getLoyaltyIsInfiniteAccountTier(state)
}

export default getShouldHideLoyaltyStatusCreditsAndNights
